/**
 * Canonical dragpin answer format.
 *
 * Scoring membandingkan string persis, jadi urutan nama di dalam room
 * harus sama antara dashboard (kunci) dan App (jawaban user).
 * App mengurutkan nama secara alfabet (localeCompare, case-insensitive).
 */

export function sortDragpinNames(names) {
  return [...(Array.isArray(names) ? names : [])].sort((a, b) => (
    String(a).localeCompare(String(b), undefined, { sensitivity: 'base' })
  ));
}

export function formatDragpinRoomAnswer(roomNumber, names) {
  const roomLabel = `Room ${roomNumber}`;
  const safeNames = (Array.isArray(names) ? names : [])
    .map((name) => String(name ?? '').trim())
    .filter(Boolean);

  if (!safeNames.length) return `${roomLabel}:null`;
  return `${roomLabel}:${sortDragpinNames(safeNames).join(',')}`;
}

/**
 * Build kunci jawaban dari mapping pinIndex -> room.
 * Nama dalam satu room diurutkan alfabet, bukan index pin.
 */
export function buildDragpinAnswerRows({ roomCount, visibleNames, pinsRoom }) {
  const safeRoomCount = Number(roomCount);
  if (!Number.isInteger(safeRoomCount) || safeRoomCount < 1 || safeRoomCount > 6) return [];

  const names = Array.isArray(visibleNames) ? visibleNames : [];
  const rooms = Array.isArray(pinsRoom) ? pinsRoom : [];
  const namesByRoom = Array.from({ length: safeRoomCount }, () => []);

  names.forEach((pinName, pinIndex) => {
    const roomValue = Number(rooms[pinIndex]);
    if (Number.isInteger(roomValue) && roomValue >= 1 && roomValue <= safeRoomCount) {
      namesByRoom[roomValue - 1].push(pinName);
    }
  });

  return namesByRoom.map((roomNames, roomIdx) => (
    formatDragpinRoomAnswer(roomIdx + 1, roomNames)
  ));
}

/**
 * Normalisasi kunci/jawaban dragpin yang sudah tersimpan supaya urutan nama
 * di tiap room mengikuti format kanonik App.
 */
export function normalizeDragpinAnswerRows(answerArr) {
  if (!Array.isArray(answerArr)) return [];

  return answerArr.map((row) => {
    if (typeof row !== 'string') return row;

    const match = row.match(/^\s*Room\s*(\d+)\s*:\s*(.*)\s*$/i);
    if (!match) return row;

    const roomNumber = Number(match[1]);
    const rawNames = (match[2] ?? '').trim();
    if (!rawNames || rawNames.toLowerCase() === 'null') {
      return formatDragpinRoomAnswer(roomNumber, []);
    }

    const names = rawNames.split(',').map((name) => name.trim()).filter(Boolean);
    return formatDragpinRoomAnswer(roomNumber, names);
  });
}
